import { Fragment } from 'react';
import { Field } from 'redux-form';

import { TextField } from 'common/components/forms';
import { phoneNormalize } from 'common/helpers/phoneHelper';

import { showAdditionalFields } from './helpers';

const PhoneFormFields = (props) => {
  const { fields } = props;
  const addField = (e) => {
    e.preventDefault();
    // Need to push an extra one if there isn't one on the stack
    if (fields.length === 0) {
      fields.push({});
    }

    fields.push({});
  };

  return (
    <>
      {renderArray(fields)}
      {renderAdditionalPhones(fields, addField)}
    </>
  );
};

const renderAdditionalPhones = (fields, addField) => {
  const shouldShowAdditional = showAdditionalFields(fields, 'phone');

  if (!shouldShowAdditional) {
    return null;
  }

  return (
    <div>
      <a className="c7-button-small" onClick={addField}>
        Add Additional Phone
      </a>
    </div>
  );
};

const renderArray = (fields) => {
  if (fields.length <= 1) {
    return (
      <Field
        name="phones[0].phone"
        component={TextField}
        autocomplete="tel-national"
        label="Phone"
        type="tel"
        normalize={phoneNormalize}
        required
      />
    );
  }
  return fields.map((phone, index) => (
    <Fragment key={phone}>
      {index === 0 && (
        <Field
          name={`${phone}.phone`}
          component={TextField}
          autocomplete="tel-national"
          label="Phone"
          type="tel"
          normalize={phoneNormalize}
          required
        />
      )}
      {index !== 0 && (
        <Field
          name={`${phone}.phone`}
          component={TextField}
          label="Additional Phone"
          autocomplete="tel-national"
          type="tel"
          normalize={phoneNormalize}
          actionButton={renderDeleteButton(fields, index)}
        />
      )}
    </Fragment>
  ));
};

const renderDeleteButton = (fields, index) => (
  <a
    className="c7-button-alt-small"
    onClick={(e) => {
      e.preventDefault();
      fields.remove(index);
    }}
  >
    Delete
  </a>
);

export default PhoneFormFields;
